import axios from '../helpers/Axios'

export default {
  async callbackCalendar(filter) {
    return await axios.post("/CompanyCallback/CallbackCalendar", filter);
  },
  async getUsers() {
    return await axios.get("/User/");
  },
  async moveCallBacks(filter) {
    return await axios.post("/CompanyCallback/MoveCallbacks", filter);
  },
  async searchCallbacks(filter) {
    return await axios.post("/CompanyCallback/Search", filter);
  },
  async transferCallbacks(form) {
    return await axios.post("/CompanyCallback/Transfer", form);
  }
}
